var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('autocomplete'),_c('slider'),_c('knob'),_c('uswitch'),_c('tags'),_c('color-picker'),_c('date-time-picker'),_c('drag-drop'),_c('floating-label'),_c('input-multiplier'),_c('masked-input'),_c('strenght-meter'),_c('long-press-button'),_c('star-rating'),_c('markdown-editor'),_c('text-editor'),_c('captcha')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }